import axiosInstance from 'helpers/axiosInstance';

import {
  CreateStripeCheckout,
  CreateStripeCheckoutResponse,
} from './types/stripe.types';

const createStripeCheckout = async (vars: CreateStripeCheckout) => {
  const url = '/patients/subscriptions/checkout';

  const response = await axiosInstance.post<CreateStripeCheckoutResponse>(
    url,
    vars,
  );
  return response.data.checkoutSession;
};

export default createStripeCheckout;
